import { useSyncExternalStore } from "react";

/**
 * The player's time, outside React state: it changes every frame, and as state
 * of the map's host it re-rendered every pin on the map at that rate.
 */
export type PlaybackClock = {
  get: () => number | null;
  set: (time: number) => void;
  subscribe: (onChange: () => void) => () => void;
};

export const createPlaybackClock = (initial: number | null = null): PlaybackClock => {
  let time = initial;
  const listeners = new Set<() => void>();
  return {
    get: () => time,
    set: (next) => {
      if (next === time) return;
      time = next;
      listeners.forEach((listener) => listener());
    },
    subscribe: (onChange) => {
      listeners.add(onChange);
      return () => listeners.delete(onChange);
    },
  };
};

/** Re-renders the caller, and only it, whenever the clock moves. */
export const usePlaybackTime = (clock: PlaybackClock): number | null =>
  useSyncExternalStore(clock.subscribe, clock.get);
